import { useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "../constants";
import { handleGetGameCategories } from "../../api-clients/gamesCategoriesClient";

interface UseGameCategoriesQueryParams {
  enabled?: boolean;
  shouldFetchAll?: boolean;
}

function useGameCategoriesQuery(params?: UseGameCategoriesQueryParams) {
  const { enabled, shouldFetchAll } = params || {};

  const query = useQuery({
    queryKey: [
      QUERY_KEYS.GAME.GAME_CATEGORIES,
      { shouldFetchAll: !!shouldFetchAll },
    ],
    queryFn: () => handleGetGameCategories(shouldFetchAll),
    enabled,
  });

  return query;
}

export default useGameCategoriesQuery;
